import React from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useSessionStore } from '../../store/sessionStore';
import './ConnectionStatusBanner.css';

export function ConnectionStatusBanner() {
  const message = useSessionStore((s) => s.connectionMessage);
  const status = useSessionStore((s) => s.status);
  const retrying = status === 'loading';

  if (!message) {
    return null;
  }

  const handleRetry = () => {
    void useSessionStore.getState().bootstrapSession({ force: true });
  };

  return (
    <Alert variant="warning" className="connection-status-banner" role="status" aria-live="polite">
      <div className="connection-status-banner__inner">
        <span className="connection-status-banner__text">{message}</span>
        <Button
          size="sm"
          variant="outline-dark"
          className="connection-status-banner__retry"
          onClick={handleRetry}
          disabled={retrying}
        >
          {retrying ? (
            <>
              <Spinner animation="border" size="sm" className="me-1" aria-hidden />
              Retrying…
            </>
          ) : (
            'Retry'
          )}
        </Button>
      </div>
    </Alert>
  );
}
